import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bd1f0d78&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bd1f0d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1f0d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd1f0d78')) {
      api.createRecord('bd1f0d78', component.options)
    } else {
      api.reload('bd1f0d78', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bd1f0d78&scoped=true&", function () {
      api.rerender('bd1f0d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KW6ZRbP2D3HY/JS/comp/DocBox.vue"
export default component.exports